import {
  IconArrowBackUp,
  IconCheck,
  IconFileText,
  IconSettings,
  IconTrash,
} from "@tabler/icons-react";

const HISTORY_TYPES = [
  { value: "created", label: "Created", color: "blue", icon: IconFileText },
  { value: "updated", label: "Updated", color: "cyan", icon: IconSettings },
  { value: "checked_in", label: "Checked in", color: "green", icon: IconCheck },
  {
    value: "checked_out",
    label: "Checked out",
    color: "orange",
    icon: IconArrowBackUp,
  },
  { value: "deleted", label: "Deleted", color: "red", icon: IconTrash },
];

const CHANGE_LABELS = {
  email: "Email",
  tags: "Tags",
};

const SOURCE_LABELS = {
  manual: "Added manually",
  import: "Imported from file",
  registration: "Registration approved",
  organizer: "Deleted by organizer",
  account_deletion: "Account deleted",
};

const CHECK_IN_METHOD_LABELS = {
  scan: "via scan",
  hand: "by hand",
};

const isCheckIn = (changeStatus) =>
  changeStatus === "checked_in" || changeStatus === "checked_out";

const getHistoryType = (changeStatus) =>
  HISTORY_TYPES.find((type) => type.value === changeStatus) ?? HISTORY_TYPES[1];

const formatValue = (value) => {
  if (Array.isArray(value)) return value.join(", ") || null;
  if (value === "" || value === null || value === undefined) return null;
  return value;
};

const getChangeLabel = (item) =>
  item.label ?? CHANGE_LABELS[item.field] ?? item.field;

// Shape expected by Registrations/ChangesList: { label: { from, to } }
const toChangesList = (change) =>
  Object.fromEntries(
    change.map((item) => [
      getChangeLabel(item),
      {
        from: formatValue(item.previousValue),
        to: formatValue(item.newValue),
      },
    ])
  );

const getFieldChanges = ({ changeStatus, change }) =>
  isCheckIn(changeStatus) ? [] : (change ?? []);

const displaySummary = ({ changeStatus, source, checkInMethod }) =>
  isCheckIn(changeStatus)
    ? CHECK_IN_METHOD_LABELS[checkInMethod]
    : SOURCE_LABELS[source];

export {
  HISTORY_TYPES,
  getHistoryType,
  getFieldChanges,
  toChangesList,
  displaySummary,
};
